import { OrderForm } from "../../types/OrderFormTypes";
import {
    Supplier,
    SupplierFullCompetitor,
    SupplierInsight,
    SupplierWithEmployee,
} from "../../types/SupplierTypes";
import { safeDELETE, safeGET, safePUT } from "./SafeClient";

// Legacy buyer briefs are view-only. Everything that created, listed, edited or
// regenerated them has been removed; what remains backs the detail viewer at
// /supplier/:id, the vendor/order-form name lookup, and delete from the V2 index.

export function getSupplierById(id: number, abort?: any): Promise<SupplierWithEmployee> {
    return safeGET(`/api/supplier/${id}`, abort);
}

export function getSupplierByName(name: string, abort?: any): Promise<Supplier> {
    return safeGET(`/api/supplier/search?name=${encodeURIComponent(name)}`, abort);
}

export function deleteSupplier(id: number, abort?: any): Promise<Supplier> {
    return safeDELETE(`/api/supplier/${id}`, undefined, abort);
}

export function getSupplierCompetitors(id: number, abort?: any): Promise<SupplierFullCompetitor[]> {
    return safeGET(`/api/supplier/${id}/competitor`, abort);
}

export function getSupplierInsights(id: number, abort?: any): Promise<SupplierInsight[]> {
    return safeGET(`/api/supplier/${id}/insight`, abort);
}

export function updateSupplierCompetitor(
    competitor: SupplierFullCompetitor,
    abort?: any
): Promise<SupplierFullCompetitor> {
    return safePUT(`/api/supplier/${competitor.supplierId}/${competitor.id}`, competitor, abort);
}

export function getSupplierOrder(id: number, abort?: any): Promise<{ data?: OrderForm }> {
    return safeGET(`/api/supplier/${id}/orderform`, abort);
}
